import { cn } from "@/libs/utils";
import { Button } from "@/v2-components/ui/button";
import MinusIcon from "@/v2-components/core/icon/minus-icon";
import PlusIcon from "@/v2-components/core/icon/plus-icon";

interface Props {
  value: number;
  decreaseDisabled: boolean;
  increaseDisabled: boolean;
  onDecrease: () => void;
  onIncrease: () => void;
  className?: string;
}

export function QuantityCounter({
  value,
  decreaseDisabled,
  increaseDisabled,
  onDecrease,
  onIncrease,
  className,
}: Props) {
  return (
    <div
      // Figma `Quota`(모바일 `28718:186969` / 데스크톱 `28718:184956`) — 98×38,
      // radius 8, padding 8, 양끝 정렬. 종전(`gap-3 px-3`)은 폭이 108 로 벌어져
      // 데스크톱 우측 컬럼(98) 을 넘쳤다.
      className={cn(
        "flex h-[38px] w-[98px] select-none items-center justify-between rounded-lg border border-coolgray-20 p-2",
        className,
      )}
      onClick={(e) => e.stopPropagation()}
    >
      <Button
        size="none"
        variant="darkgray-text"
        disabled={decreaseDisabled}
        className="hover:text-coolgray-70"
        onClick={(e) => {
          e.preventDefault();
          onDecrease();
        }}
      >
        <MinusIcon className="h-5 w-5" />
      </Button>
      {/* 최소 폭 20 — 1자리↔2자리에서 좌우 아이콘이 움직이면 연타 시 오조작이 난다.
          ⚠️ `w-5`(고정)가 아니라 `min-w-5` 다. 상한이 상수 4 인 호출처(`cart-item`)만
          있는 게 아니라 `maxQuantity` 를 변수로 받는 곳(`accessory-item` ·
          `sku-options-dialog` 의 `getMaxForSku`)이 있어서, 3자리가 구조적으로
          막혀 있지 않다. 고정 폭이면 그때 숫자가 아이콘 위로 넘친다. */}
      <span className="min-w-5 text-center text-lg text-blue-60">{value}</span>
      <Button
        size="none"
        variant="darkgray-text"
        className="hover:text-coolgray-70"
        disabled={increaseDisabled}
        onClick={(e) => {
          e.preventDefault();
          onIncrease();
        }}
      >
        <PlusIcon className="h-5 w-5" />
      </Button>
    </div>
  );
}
